module.exports = __webpack_public_path__ + "img/logo.1a4e737c.svg";